var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _vm.reservation.show || 1
                        ? _c(
                            "v-container",
                            { attrs: { fluid: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("h2", [_vm._v("Edit Stay Dates")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _vm._v(
                                      "Please choose the new stay dates and provide a reason for the change"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "2" } },
                                    [_c("label", [_vm._v("Arrival Date:")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "10" } },
                                    [
                                      _c("v-date-picker", {
                                        attrs: { landscape: "" },
                                        model: {
                                          value: _vm.arrivalDate,
                                          callback: function ($$v) {
                                            _vm.arrivalDate = $$v
                                          },
                                          expression: "arrivalDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "2" } },
                                    [_c("label", [_vm._v("Departure Date:")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "10" } },
                                    [
                                      _c("v-date-picker", {
                                        attrs: { landscape: "" },
                                        model: {
                                          value: _vm.departureDate,
                                          callback: function ($$v) {
                                            _vm.departureDate = $$v
                                          },
                                          expression: "departureDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "2" } },
                                    [_c("label", [_vm._v("Reason:")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "10" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { name: "reason" },
                                        model: {
                                          value: _vm.reason,
                                          callback: function ($$v) {
                                            _vm.reason = $$v
                                          },
                                          expression: "reason",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { title: "Cancel without changes" },
                          on: { click: _vm.cancel },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          attrs: {
                            title: "Save the changes to the reservation",
                          },
                          on: { click: _vm.saveChanges },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }